import { AdvanceTableConfig } from '@aibees/shared/features';

export const ARK_API_DOCS_URL = 'https://docs.ai-ark.com/';
export const ARK_STATUS_URL = 'https://status.ai-ark.com/';
export const MAXIMUM_API_KEYS_LIMIT = 10;

// Public developer-portal search endpoints + their API-reference pages
// (shown in the Search Payload dialog's API Payload tab).
export const ARK_API_COMPANY_SEARCH_URL =
  'https://api.ai-ark.com/api/developer-portal/v1/companies';
export const ARK_API_PEOPLE_SEARCH_URL =
  'https://api.ai-ark.com/api/developer-portal/v1/people';
export const ARK_API_DOCS_COMPANY_SEARCH_URL = `${ARK_API_DOCS_URL}reference/company-search-1`;
export const ARK_API_DOCS_PEOPLE_SEARCH_URL = `${ARK_API_DOCS_URL}reference/people-search-1`;

export const API_PANEL_SHARED_TABLE_CONFIG: Partial<AdvanceTableConfig> = {
  defaultOrderBy: 'created',
  hideColumnsOnNoData: true,
  emptyProps: {
    filled: false,
    imgUrl: '/assets/images/empty-search-result.svg',
    title: undefined,
    description: 'No Results Found',
    descriptionSx: {
      mt: 2,
      fontSize: '18px',
      color: 'text',
      fontWeight: 700,
    },
  },

  hideResetFilters: true,
  filtersSx: { px: 0, pt: 1, itemsSx: { flexDirection: 'column', gap: 2 } },
  actionsConfig: {
    label: 'Action',
    minWidth: '10%',
    align: 'center',
    sx: { display: 'flex', justifyContent: 'center' },
  },
  cellSx: { p: (p) => p.spacing(1) },
  bordered: 'dashed',
};
